import { clsx, type ClassValue } from "clsx"
import dayjs from "dayjs"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function createSessionName(date: Date = new Date()) {
  return dayjs(date).format('ddd DD-MMM-YYYY hh:mm A')
}

export function getBaseBackendUrl(): string {
  const backendUrlString = (process.env as any)?.VITE_BACKEND_URL as string

  const url = new URL(backendUrlString)
  return url.origin

}